import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_websoft/layout/core'
import ArtikliOperacijeLista from "./ArtikliOperacijeLista";
import ArtikliOperacijeDetails from "./ArtikliOperacijeDetails";
import ZapisiProizvodnjeLista from "./ZapisiProizvodnjeLista";
import ZapisiProizvodnjeDetails from "./ZapisiProizvodnjeDetails";
import PlaviNalogLista from "./PlaviNalogLista";
import PlaviNalogDetails from "./PlaviNalogDetails";
import ProductionAnalyticsPage from "./ProductionAnalyticsPage";
import ProductionSurplusPage from "./ProductionSurplusPage";

const GalanterijaBreadCrumbs: Array<PageLink> = [
    {
        title: 'Galanterija',
        path: '/galanterija/artikli-operacije',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const GalanterijaRoutes: React.FC = () => {
    return (
        <Routes>
            <Route
                element={
                    <>
                        <Outlet />
                    </>
                }
            >
            <Route
                path='artikli-operacije'
                element={
                    <>
                        <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Artikli operacije</PageTitle>
                        <ArtikliOperacijeLista />
                    </>
                }
            />
            <Route
                path='artikli-operacije/dodaj'
                element={
                    <>
                        <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Dodaj</PageTitle>
                        <ArtikliOperacijeDetails />
                    </>
                }
            />
            <Route
                path='artikli-operacije/izmjena/:id'
                element={
                    <>
                        <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Izmjena</PageTitle>
                        <ArtikliOperacijeDetails />
                    </>
                }
            />
                <Route
                    path='zapisi-proizvodnje'
                    element={
                        <>
                            <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Zapisi proizodnje</PageTitle>
                            <ZapisiProizvodnjeLista />
                        </>
                    }
                />
                <Route
                    path='zapisi-proizvodnje/izmjena/:id'
                    element={
                        <>
                            <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Zapisi proizodnje izmjena</PageTitle>
                            <ZapisiProizvodnjeDetails />
                        </>
                    }
                />
                <Route
                    path='plavi-nalog'
                    element={
                        <>
                            <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Plavi nalozi</PageTitle>
                            <PlaviNalogLista />
                        </>
                    }
                />
                <Route
                    path='plavi-nalog/:id'
                    element={
                        <>
                            <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Plavi nalog detalji</PageTitle>
                            <PlaviNalogDetails />
                        </>
                    }
                />
                <Route
                    path='plavi-nalog/:id/analitika'
                    element={
                        <>
                            <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Analitika plavog naloga</PageTitle>
                            <ProductionAnalyticsPage />
                        </>
                    }
                />
                <Route
                    path='visak-proizvodnje'
                    element={
                        <>
                            <PageTitle breadcrumbs={GalanterijaBreadCrumbs}>Višak proizvodnje</PageTitle>
                            <ProductionSurplusPage />
                        </>
                    }
                />
                <Route index element={<Navigate to='/galanterija/lista' />} />
            </Route>
    </Routes>
    )
}

export default GalanterijaRoutes
